import { useId } from 'react'
import { observer } from 'mobx-react-lite'
import type { PersonalInfoRequestedSupportingItemViewModel } from '@/features/jobs/details/tax-type/info-gathering/personal-info/PersonalInfoRequestedSupportingItemViewModel'
import { PersonalProfileEditor } from '@/features/tax-profile/individual-profiles/components/PersonalProfileEditor'
import type { TaxInfoGatheringViewModel } from '@/features/jobs/details/tax-type/info-gathering/TaxInfoGatheringViewModel'
import { TaxInfoGatheringWizardContentButtonGroupContainer } from '@/features/jobs/details/tax-type/info-gathering/components/TaxInfoGatheringWizardContentButtonGroupContainer'
import { WizardContentBody, WizardContentFooter } from '@/components/Wizard'

export interface PersonalInfoWizardContentProps {
  itemVm: PersonalInfoRequestedSupportingItemViewModel
  taxInfoGatheringVm: TaxInfoGatheringViewModel
}

/**
 * The PersonalInfoWizardContent
 */
export const PersonalInfoWizardContentContainer = observer(
  function PersonalInfoWizardContentContainer({
    itemVm,
    taxInfoGatheringVm,
  }: PersonalInfoWizardContentProps) {
    const formId = useId()
    const isSkeleton = itemVm.fetch.pending
    const isCompleteInfoGatheringPending =
      taxInfoGatheringVm.confirmCompleteInfoGathering.pending
    return (
      <>
        <WizardContentBody>
          <PersonalProfileEditor
            isSkeleton={isSkeleton}
            formId={formId}
            vm={itemVm.personalProfileEditorVm}
            isDisabled={
              itemVm.personalProfileEditorVm.save.pending ||
              isCompleteInfoGatheringPending
            }
          />
        </WizardContentBody>

        <WizardContentFooter>
          <TaxInfoGatheringWizardContentButtonGroupContainer
            isSkeleton={isSkeleton}
            variant="save"
            formId={formId}
            isSavePending={itemVm.personalProfileEditorVm.save.pending}
            taxInfoGatheringVm={taxInfoGatheringVm}
            itemVm={itemVm}
          />
        </WizardContentFooter>
      </>
    )
  },
)
